export const API_SUCCESS = 'API_SUCCESS';
export const API_FAIL = 'API_FAIL';
